import Alerts from '../views/alerts/Index.vue';
import { checkauth } from '../Helper';

const guard = (to, from, next) => {
	checkauth().then(response => (response ? next() : next('/login')));
};

export default [{ path: '/ecommerce/alerts', name: 'alerts', component: Alerts, beforeEnter: guard }];
